
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '@/components/Layout';
import SearchInput from '@/components/Search/SearchInput';
import SearchFilters from '@/components/Search/SearchFilters';
import SearchContent from '@/components/Search/SearchContent';
import { useSearchLogic } from '@/hooks/useSearchLogic';
import { useIsMobile } from '@/hooks/use-mobile';

const Search = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const {
    query,
    searchResults,
    isSearching,
    includeStories,
    includeVideos,
    handleSearchChange,
    clearSearch,
    setIncludeStories,
    setIncludeVideos
  } = useSearchLogic();
  
  const navigateToContent = (path: string) => {
    navigate(path);
  };
  
  const handleTagClick = (tag: string) => {
    // Reset query to just the tag
    clearSearch();
    // Set the new query
    handleSearchChange({
      target: {
        value: tag
      }
    } as React.ChangeEvent<HTMLInputElement>);
  };
  
  const showFilters = query.length > 0;
  
  return (
    <Layout>
      <div className="container mx-auto px-4 py-6">
        <div className={`mx-auto ${isMobile ? 'w-full' : 'max-w-4xl'}`}>
          <h1 className="mb-4 font-normal text-xl sm:text-2xl text-center">Search</h1>
          
          <div className="mb-4 sm:mb-6">
            <SearchInput 
              query={query} 
              onChange={handleSearchChange} 
              onClear={clearSearch} 
              autoFocus={!isMobile} 
              placeholder="Search for titles, content, tags..." 
            />
          </div>
          
          {showFilters && 
            <SearchFilters 
              includeStories={includeStories} 
              setIncludeStories={setIncludeStories} 
              includeVideos={includeVideos} 
              setIncludeVideos={setIncludeVideos} 
            />
          }
          
          <SearchContent 
            query={query} 
            isSearching={isSearching} 
            searchResults={searchResults} 
            onItemClick={navigateToContent} 
            onTagClick={handleTagClick} 
          />
        </div>
      </div>
    </Layout>
  );
};

export default Search;
